import React from 'react';
import { Box, Button, MenuItem, TextField } from '@mui/material';
import { compactFieldSx } from '../constants';
import { getLocalizedBreakoutLabel } from '../utils/labels';

export default function PreparationFilters({
  t,
  i18n,
  filters,
  setFilters,
  metadata,
  loading,
  getRegimeLabel,
  onApply,
}) {
  return (
    <Box sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(2, minmax(0, 1fr))',
        sm: 'repeat(4, minmax(0, 1fr))',
        lg: 'repeat(4, minmax(110px, 1fr)) auto',
      },
      gap: 0.85,
      alignItems: 'stretch',
      py: 0.25,
      borderBottom: '1px solid #eef2f7',
    }}>
      <TextField
        label={t('preparation.filters.minScore.label')}
        type="number"
        size="small"
        value={filters.min_score}
        onChange={(e) => setFilters((p) => ({ ...p, min_score: Number(e.target.value || 0) }))}
        InputLabelProps={{ shrink: true }}
        sx={{ ...compactFieldSx, width: '100%' }}
      />
      <TextField
        select
        label={t('preparation.filters.marketRegime.label')}
        size="small"
        value={filters.market_regime}
        onChange={(e) => setFilters((p) => ({ ...p, market_regime: e.target.value }))}
        disabled={!metadata}
        InputLabelProps={{ shrink: true }}
        SelectProps={{
          displayEmpty: true,
          renderValue: (value) => (value ? getRegimeLabel(value) : t('common.all')),
        }}
        sx={{ ...compactFieldSx, width: '100%' }}
      >
        <MenuItem value="">{t('common.all')}</MenuItem>
        {(metadata?.market_regimes || []).map((regimeOption) => (
          <MenuItem key={regimeOption.code} value={regimeOption.code}>
            {getLocalizedBreakoutLabel(regimeOption, i18n.resolvedLanguage)}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label={t('preparation.filters.triggerFilter.label')}
        size="small"
        value={filters.exclude_trigger_none ? 'EXCLUDE' : 'ALL'}
        onChange={(e) => setFilters((p) => ({ ...p, exclude_trigger_none: e.target.value === 'EXCLUDE' }))}
        InputLabelProps={{ shrink: true }}
        sx={{ ...compactFieldSx, width: '100%' }}
      >
        <MenuItem value="ALL">{t('preparation.filters.triggerFilter.options.ALL')}</MenuItem>
        <MenuItem value="EXCLUDE">{t('preparation.filters.triggerFilter.options.EXCLUDE')}</MenuItem>
      </TextField>
      <TextField
        label={t('preparation.filters.limit.label')}
        type="number"
        size="small"
        value={filters.limit}
        onChange={(e) => setFilters((p) => ({ ...p, limit: Number(e.target.value || 50) }))}
        InputLabelProps={{ shrink: true }}
        sx={{ ...compactFieldSx, width: '100%' }}
      />
      <Button
        variant="contained"
        size="small"
        onClick={onApply}
        disabled={loading}
        sx={{
          textTransform: 'none',
          fontWeight: 700,
          height: 36,
          width: '100%',
          gridColumn: { xs: '1 / -1', lg: 'auto' },
          bgcolor: '#2563eb',
          boxShadow: 'none',
          '&:hover': { bgcolor: '#1d4ed8', boxShadow: 'none' },
        }}
      >
        {t('common.apply')}
      </Button>
    </Box>
  );
}
